let refreshPromise = null;

export const useRefreshSession = () => {
  if (!refreshPromise) {
    refreshPromise = useRefreshAccessToken(useTokens().refresh)
      .then((newAccessToken) => {
        if (!newAccessToken) throw new Error('Failed to refresh access token');
        useTokens().setAccessToken(newAccessToken);
        useUser().setTokens(newAccessToken, useTokens().refresh);
        return newAccessToken;
      })
      .catch(async (refreshError) => {
        await useLogout('/login');
        throw refreshError;
      })
      .finally(() => {
        refreshPromise = null;
      });
  }
  return refreshPromise;
}
